"use strict";

var _interopRequireWildcard = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("echarts/core");
var _renderers = require("echarts/renderers");
var _charts = require("echarts/charts");
var _components = require("echarts/components");
var _vueEcharts = _interopRequireWildcard(require("vue-echarts"));
var _vue = require("vue");
(0, _core.use)([_renderers.CanvasRenderer, _charts.PieChart, _components.TitleComponent, _components.TooltipComponent, _components.LegendComponent]);
var _default = exports.default = (0, _vue.defineComponent)({
  name: 'TasksFunnelChart',
  components: {
    VChart: _vueEcharts.default
  },
  provide: {
    [_vueEcharts.THEME_KEY]: 'light'
  },
  props: {
    dateRange: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup() {
    const option = (0, _vue.ref)({
      title: {
        text: 'Tasks',
        left: 10,
        top: 10,
        textStyle: {
          color: '#121212',
          fontSize: 16,
          fontWeight: 'normal',
          fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c}%'
      },
      textStyle: {
        fontSize: 10,
        fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
      },
      color: ['#ee6666', '#91cc75', '#5470c6', '#fac858'],
      series: [{
        name: 'Tasks',
        type: 'funnel',
        left: '10%',
        top: 50,
        bottom: 20,
        width: '80%',
        min: 0,
        max: 100,
        minSize: '0%',
        maxSize: '100%',
        sort: 'descending',
        gap: 2,
        label: {
          show: true,
          position: 'inside'
        },
        labelLine: {
          length: 10,
          lineStyle: {
            width: 1,
            type: 'solid'
          }
        },
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1
        },
        emphasis: {
          label: {
            fontSize: 10
          }
        },
        data: [{
          value: 100,
          name: 'Click'
        }, {
          value: 60,
          name: 'Visit'
        }, {
          value: 30,
          name: 'Inquiry'
        }, {
          value: 10,
          name: 'Order'
        }]
      }]
    });
    return {
      option
    };
  }
});